 /*
 * 公共验证及方法。

 * IsNull		            验证是否为空
 * IsLetter		            验证是否为英文字母
 * IsHex		            验证是否为十六进制字符串
 * IsInteger	            验证是否为整数
 * IsSim	                验证SIM卡号格式是否正确
 * IsPhone	                验证手机号格式是否正确
 * checkTel	                验证电话号码格式是否正确
 * IsDouble	                验证字符是否为双精度
 * IsString	                验证是否为字符串
 * IsEnlish	                验证字符是否为:a-z,A-Z,0-9
 * IsChinese	            验证是否为中文
 * IsEmail	                验证EMAIL格式
 * IsIP  	                验证IP格式
 * IsNum183  	            验证decimal(18, 3)数值
 * isPositiveInteger  	    验证是否为正整数
 * IsChineseAndLetter  	    验证是否中文及字母组合
 * IsNumber           	    验证是否为数字
 * IsNumberForZero          验证是否为数字（验证零和非零开头的数字）
 * 
 * strFilter                过滤表情及特殊符号。（录入文本域的字符串验证，返回过滤后的字符串）
 * valuetoFixed             保留指定小数位数方法
 * 
 * IsDate                   验证日期类型是否为 YYYY-(/)MM-(/)DD 格式的类型 returns {Boolean}
 * IsDateTime               验证日期类型是否为YYYY-(/)MM-(/)DD hh:mm:ss格式的类型 returns {Boolean}
 * IsTime                   验证是否为hh:mm:ss格式的类型 returns {Boolean}
 * 
 * formateDate              日期处理为YYYY-MM-DD格式
 * formateDateStr           日期处理为YYYY年MM月DD日格式
 * stringToDate             日期处理为自定义连接符格式，默认为 - 连接
 * 
 * getMonthDays             获得当前年份指定月份的天数
 * getQuarterStartMonth     获得本季度的开始月份
 * getWeekStartDate         获得本周的开始日期
 * getWeekEndDate           获得本周的结束日期
 * getMonthStartDate        获得本月的开始日期
 * getMonthEndDate          获得本月的结束日期
 * getLastMonthStartDate    获得上月的开始日期
 * getLastMonthEndDate      获得上月的结束日期
 * getQuarterStartDate      获得本季度的开始日期
 * getQuarterEndDate        获得本季度的结束日期
 * 
 * timeToStamp              日期/时间转为时间戳
 * timestampToTime          时间戳转为 YYYY-MM-DD hh:mm:ss 时间格式
 * timestampToDate          时间戳转为 YYYY-MM-DD 日期格式
 *
 */

/**
 * 验证方法：
 * @param val
 * @returns {Boolean}
 */
var reg;
// 判断输入内容是否为空
export function IsNull(val) {
    if (val == undefined) {
        return true
    }
    var str = (val + "").trim();
    if (str.length == 0) {
        return true;
    }
    return false;
}
// 判断输入的字符是否为英文字母
export function IsLetter(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^[a-zA-Z]+$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 验证是否是十六进制字符串
export function IsHex(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^[A-Fa-f0-9]+$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 判断输入的字符是否为整数
export function IsInteger(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = (val + "").trim();
    reg = /^[-+]?\d*$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// SIM卡号验证
export function IsSim(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^1[0-9]+$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 手机号验证
export function IsPhone(val) {
    if (IsNull(val)) {
        return false;
    }
    reg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[03678]{1})|(15[0-3]{1})|(15[5-9]{1})|(18[0-9]{1}))+\d{8})$/;
    if (val.length != 11) {
        return false;
    } else if (reg.test(val)) {
        return true;
    }
    return false;
}
// 电话号码验证
export function checkTel(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^(\d{3,4}-)\d{7,8}$/;
    if (reg.test(str)) {
        return true;
    }

    return false;
}
// 判断输入的字符是否为双精度
export function IsDouble(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = (val+"").trim();
    reg = /^[-\+]?\d+(\.\d+)?$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 字符串验证
export function IsString(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^[\u0391-\uFFE5a-zA-Z0-9_-]+$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 判断输入的字符是否为:a-z,A-Z,0-9
export function IsEnlish(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();
    reg = /^[a-zA-Z0-9_-]+$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 判断输入的字符是否为中文
export function IsChinese(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();

    reg = /^[\u0391-\uFFE5]+$/;
    if (reg.test(str)) {
        return true;
    }

    return false;
}
// 判断输入的EMAIL格式是否正确
export function IsEmail(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();

    reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (reg.test(str)) {
        return true;
    }
    return false;

}
// 判断输入的IP格式是否正确
export function IsIP(val) {
    if (IsNull(val)) {
        return false;
    }
    var str = val.trim();

    reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    if (reg.test(str)) {
        return true;
    }
    return false;
}
// 验证decimal(18, 3)数值。
export function IsNum183(value){
    let numReg = new RegExp('^[0-9](\\d{0,17})((\\.\\d{1,3})?)$');
    if(numReg.test(value)){
        return true;
    }else{
        return false;
    }
}
// 判断是否为正整数
export function isPositiveInteger(s){
	var re = /^[0-9]*[1-9][0-9]*$/ ;
	return re.test(s)
}  
// 判断是否为中文、字母组合
export function IsChineseAndLetter(s){
	var re = /^[a-zA-Z\u4e00-\u9fa5]+$/;
	return re.test(s);
}
// 判断是否为数字
export function IsNumber(value){
	var re =/^[+-]?\d*\.?\d*$/;
	return re.test(value);
}
// 判断是否为数字（验证零和非零开头的数字）
export function IsNumberForZero(value){
	var re =/^(0|[1-9][0-9]*)$/;
	return re.test(value);
}

// 过滤表情及特殊符号。（录入文本域的字符串验证，返回过滤后的字符串）
export function strFilter(s) {
    s = s.replace(/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/g, "");
    s = s.replace(/[^\u4e00-\u9fa5a-zA-Z\d,\.，。!！：:（）()《》<>"“”%？?]+/g, "");
    return s;
}
/* 
*  保留指定小数位数 
*  @param cellValue 待处理数据
*  @param num 指定保留小数位数
*  @returns result，待处理数据为空或非数值返回 -- 
*/
export function valuetoFixed(cellValue, num) {
    if(cellValue == null && cellValue != 0){
        return '--';
    }else if((cellValue == -Infinity || cellValue == '' || cellValue == undefined)&& cellValue != 0){
        return '--';
    }else{
        return (cellValue*1).toFixed(num);
    }
}

/*
 * 日期验证
 * @param val
 * @returns {Boolean}
*/
// 判断日期类型是否为 YYYY-(/)MM-(/)DD 格式的类型
export function IsDate(val) {
	if(IsNull(val)){
		return false;
	}
	var str = val.trim();
	var reg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;
	if(reg.test(str)){
		return true;
	}
	return false;
}
// 判断日期类型是否为YYYY-(/)MM-(/)DD hh:mm:ss格式的类型
export function IsDateTime(val) {
	if(IsNull(val)){
		return false;
	}
	var str = val.trim();
	var reg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
	if (reg.test(str)){
		return true;
	}
	return false;
}
// 判断日期类型是否为hh:mm:ss格式的类型
export function IsTime(val) {
	if(IsNull(val)){
		return false;
	}
	var str = val.trim();
	reg = /^((20|21|22|23|[0-1]\d)\:[0-5][0-9])(\:[0-5][0-9])?$/
	if (reg.test(str)) {
		return true;
	}
	return false;
}
// 月份的范围
export function formatRangeMonth(rangeDate = []){
    if(rangeDate.length === 0) return
    let startDate = rangeDate[0];
    let endDate = rangeDate[1];
    startDate = startDate.getMonth() > 9 
    ? startDate = startDate.getFullYear()+ "-" + (startDate.getMonth()+1)
    : startDate = startDate.getFullYear()+ "-0" + (startDate.getMonth()+1);
    endDate = endDate.getMonth() > 9 
    ? endDate = endDate.getFullYear()+ "-" + (endDate.getMonth()+1)
    : endDate = endDate.getFullYear()+ "-0" + (endDate.getMonth()+1);
    return {start:startDate,end:endDate}
}
// 日的范围
export function formatRangeDay(rangeDate = []){
    if(rangeDate.length === 0) return
    let startDate = rangeDate[0];
    let endDate = rangeDate[1];
    startDate = startDate.getMonth() > 9
    ? startDate.getFullYear()+ "-" + (startDate.getMonth()+1) +'-'+ startDate.getDate()
    : startDate.getFullYear()+ "-0" + (startDate.getMonth()+1) +'-'+ startDate.getDate();
    endDate = endDate.getMonth() > 9
    ? endDate.getFullYear()+ "-" + (endDate.getMonth()+1) +'-'+ endDate.getDate()
    : endDate.getFullYear()+ "-0" + (endDate.getMonth()+1) +'-'+ endDate.getDate();
    return {start:startDate,end:endDate}
}
/*
 * 日期处理方法
 * @param time
 * @returns result
*/
// Date处理为YYYY-MM格式
export function formateMonth(time){
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let day = time.getDate();

    if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month;
 } 
/*
 * 日期处理方法
 * @param time
 * @returns result
*/
// Date处理为YYYY-MM-DD格式
export function formateDate(time){
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let day = time.getDate();

    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    return year + '-' + month + '-' + day + '';
 } 
// Date处理为YYYY年MM月DD日格式
 export function formateDateStr(time){
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let day = time.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    return year + '年' + month + '月' + day + '日';
 } 

 /**
 * 字符串转为日期 格式为yyyy-MM-dd
 * @param dateStr
 * @param separator
 * @returns {Date}
 */
export function stringToDate(dateStr, separator) {
    if (!separator) {
        separator = "-";
    }
    let dateArr = dateStr.split(separator);
    let year = parseInt(dateArr[0]);
    let month;
    //处理月份为04这样的情况
    if (dateArr[1].indexOf("0") == 0) {
        month = parseInt(dateArr[1].substring(1));
    } else {
        month = parseInt(dateArr[1]);
    }
    let day = parseInt(dateArr[2]);
    let date = new Date(year, month - 1, day);
    return formateDate(date);
}

/**
    * 获取本周、本季度、本月、上月的开始日期、结束日期
*/
let now = new Date(); //当前日期 
let nowDayOfWeek = now.getDay(); //今天本周的第几天 
let nowDay = now.getDate(); //当前日 
let nowMonth = now.getMonth(); //当前月 
let nowYear = now.getYear(); //当前年 
nowYear += (nowYear < 2000) ? 1900 : 0; //

let lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
let lastYear = lastMonthDate.getYear();
let lastMonth = lastMonthDate.getMonth();

// 获得某月的天数 
export function getMonthDays(myMonth) {
    myMonth = myMonth - 1;
    let monthStartDate = new Date(nowYear, myMonth, 1);
    let monthEndDate = new Date(nowYear, myMonth + 1, 1);
    let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
}
// 获得本季度的开始月份 
export function getQuarterStartMonth() {
    let quarterStartMonth = 0;
    if (nowMonth < 3) {
        quarterStartMonth = 0;
    }
    if (2 < nowMonth && nowMonth < 6) {
        quarterStartMonth = 3;
    }
    if (5 < nowMonth && nowMonth < 9) {
        quarterStartMonth = 6;
    }
    if (nowMonth > 8) {
        quarterStartMonth = 9;
    }
    return quarterStartMonth + 1;
}
// 获得本周的开始日期 
export function getWeekStartDate() {
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
    return formateDate(weekStartDate);
}
// 获得本周的结束日期 
export function getWeekEndDate() {
    let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
    return formateDate(weekEndDate);
}
// 获得本月的开始日期 
export function getMonthStartDate() {
    let monthStartDate = new Date(nowYear, nowMonth, 1);
    return formateDate(monthStartDate);
}
// 获得本月的结束日期 
export function getMonthEndDate() {
    let monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    return formateDate(monthEndDate);
}
// 获得上月开始日期
export function getLastMonthStartDate() {
    let lastMonthStartDate = new Date(nowYear, lastMonth, 1);
    return formateDate(lastMonthStartDate);
}
// 获得上月结束日期
export function getLastMonthEndDate() {
    let lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth + 1));
    return formateDate(lastMonthEndDate);
}
// 获得本季度的开始日期 
export function getQuarterStartDate() {
    let quarterStartDate = new Date(nowYear, getQuarterStartMonth() - 1, 1);
    return formateDate(quarterStartDate);
}
// 或的本季度的结束日期 
export function getQuarterEndDate() {
    let quarterEndMonth = getQuarterStartMonth() + 2;
    let quarterStartDate = new Date(nowYear, quarterEndMonth - 1, getMonthDays(quarterEndMonth));
    return formateDate(quarterStartDate);
}
// 日期/时间转为时间戳
export function timeToStamp(str){
  var str2 = Date.parse(new Date(str));
  return(str2/ 1000);
}
// 时间戳转为 YYYY-MM-DD hh:mm:ss 时间格式
export function timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
    var strDate = Y+M+D+h+m+s;
    return strDate;
}
/**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
 */
export function  getDaysBetween(dateString1,dateString2){
    var  startDate = Date.parse(dateString1);
    var  endDate = Date.parse(dateString2);
    if (startDate>endDate){
        return 0;
    }
    if (startDate==endDate){
        return 1;
    }
    var days=(endDate - startDate)/(1*24*60*60*1000);
    return  days;
}